import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FeatureConfigService, OCC_USER_ID_CURRENT, Product, ProductScope, UserIdService } from '@spartacus/core';
import { CurrentProductService, ProductDetailOutlets } from '@spartacus/storefront';
import { map, Observable } from 'rxjs';

@Component({
  selector: 'cx-product-summary',
  templateUrl: './product-summary.component.html',
  styleUrl: './product-summary.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CustomProductSummaryComponent {
  private featureConfig = inject(FeatureConfigService);

  outlets = ProductDetailOutlets;

  product$: Observable<Product | null> = this.getProduct();
  isLogged$ = this.userIdService.getUserId().pipe(map(userID => userID === OCC_USER_ID_CURRENT));

  protected getProduct(): Observable<Product | null> {
    const productScopes = [ProductScope.DETAILS, ProductScope.PRICE];
    if (this.featureConfig.isEnabled('showPromotionsInPDP')) {
      productScopes.push(ProductScope.PROMOTIONS);
    }
    return this.currentProductService.getProduct(productScopes);
  }

  constructor(
    protected currentProductService: CurrentProductService,
    private userIdService: UserIdService,
  ) {}
}
